<template>
  <!--begin::Wrapper-->
  <div id="dnn_ctr464_ModuleContent" class="DNNModuleContent ModDNNHTMLC">
    <div id="dnn_ctr464_HtmlModule_lblContent" class="Normal">
      <div class="pageBg">
        <div class="pageBgInner mt-10" data-aos="fade-up">

          <div class="container container-small">
            <div class="row">
              <div class="col-md-12">
                <div class="card"></div>
                <div class="w-lg-500px bg-white rounded shadow-sm p-10 p-lg-15 mt-20 mx-auto">
                  <!--begin::Form-->
                  <Form
                      class="form w-100"
                      id="kt_login_signin_form"
                      @submit="onSubmitLogin"
                  >
                    <!--begin::Heading-->
                    <div class="text-center mb-10">
                                                    <span class='symbol symbol-70px symbol-circle me-6'>
                                                      <span class='bg-light-danger symbol-label symbol-label'>
                                                        <span class='svg-icon svg-icon-1 svg-icon-danger'>
                                                                <i class="uil uil-lock fs-1 text-danger button_icon"></i>
                                                        </span>
                                                      </span>
                                                    </span>
                      <!--begin::Title-->
                      <h1 class="text-dark mt-5 mb-3">{{$t('reset_password')}}</h1>
                      <!--end::Title-->
                    </div>
                    <!--begin::Heading-->



                    <div class="fv-row">
                      <!--begin::Label-->
                      <label class="form-label fs-6 fw-bolder required text-dark">{{$t('new_password')}}</label>
                      <!--end::Label-->

                      <!--begin::Input-->
                      <Field
                          class="form-control form-control-lg form-control-solid"
                          :rules="{required:true,confirmed:'@password_confirmation',regex:'^(?=.*[a-zA-Z])(?=.*\\d)(?=.*[\\W_]).{8,}$'}"
                          v-model="password" :label="$t('new_password')"
                          name="password" type="password"  ref="Ipassword"
                          autocomplete="off"
                      />
                      <!--end::Input-->
                      <div class="fv-plugins-message-container">
                        <div class="fv-help-block">
                          <ErrorMessage name="password"/>
                        </div>
                      </div>
                    </div>
                    <div class="fv-row">
                      <label class="form-label fs-6 fw-bolder required text-dark">{{$t('password_confirmation')}}</label>
                      <Field
                          class="form-control form-control-lg form-control-solid"
                          :rules="{required:true,regex:'^(?=.*[a-zA-Z])(?=.*\\d)(?=.*[\\W_]).{8,}$'}"
                          v-model="password_confirmation" :label="$t('new_password')"
                          name="password_confirmation" type="password"
                          autocomplete="off"
                      />
                      <!--end::Input-->
                      <div class="fv-plugins-message-container">
                        <div class="fv-help-block">
                          <ErrorMessage name="password_confirmation"/>
                        </div>
                      </div>
                    </div>
                    <div class="alert alert-warning">
                      <ul style="font-size: 12px;font-weight: bold">
                        <li class="m-0 text-capitalize" style="max-height: 24px">○ {{$t('pass_1')}}</li>
                        <li class="m-0 text-capitalize" style="max-height: 24px">○ {{$t('pass_4')}}</li>
                        <li class="m-0 text-capitalize" style="max-height: 24px">○ {{$t('pass_2')}}</li>
                        <li class="m-0 text-capitalize" style="max-height: 24px">○ {{$t('pass_3')}}</li>
                      </ul>
                    </div>
                    <!--end::Input group-->

                    <!--begin::Actions-->
                    <div class="text-center">
                      <!--begin::Submit button-->
                      <button
                          type="submit"
                          ref="submitButton"
                          id="kt_sign_in_submit"
                          class="btn btn-lg btn-danger w-100 mt-5"
                      >
                        <span class="indicator-label"> {{$t('send')}} </span>

                        <span class="indicator-progress">
            {{$t('loading')}}
            <span
                class="spinner-border spinner-border-sm align-middle ms-2"
            ></span>
          </span>
                      </button>
                      <!--end::Submit button-->


                    </div>
                    <!--end::Actions-->
                  </Form>
                  <!--end::Form-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cloudsTop"></div>
    </div>

  </div>
  <!--end::Wrapper-->
</template>

<script lang="ts">
import {defineComponent, ref, reactive, toRefs, inject , onMounted} from "vue";
import {ErrorMessage, Field, Form} from "vee-validate";
import {Actions} from "@/store/enums/StoreEnums";
import {useStore} from "vuex";
import {useRouter,useRoute} from "vue-router";
import {useI18n} from 'vue-i18n';
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import * as Yup from "yup";
import AOS from "aos";

export default defineComponent({
  name: "sign-in",
  components: {
    Field,
    Form,
    ErrorMessage,
  },
  setup() {
    const helpers: any = inject("helpers");
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const i18n = useI18n();
    const {t} = useI18n();


    onMounted(() => {
      AOS.init();
    });


    const state = reactive({
      password: null,
      password_confirmation: null,
    });

    const submitButton = ref<HTMLElement | null>(null);

    //Form submit function
    const onSubmitLogin = (values, form) => {
      // Clear existing errors
      store.dispatch("moduleAuth/logout");

      if (!form) {
        return;
      }

      if (submitButton.value) {
        // Activate indicator
        submitButton.value.setAttribute("data-kt-indicator", "on");
        submitButton.value.setAttribute("disabled", "true");
      }

      const {setErrors} = form;

      // Dummy delay
      setTimeout(() => {
        // Send login request
        let payload = {
          "password": state.password,
          "token":route.params.token
        };
        store
            .dispatch("moduleAuth/resetPassword", payload)
            .then((response) => {
              helpers.successNotify(t("success"), t("success_msg"));

              router.push({name:"login_page"})
              //Deactivate indicator
              submitButton.value?.removeAttribute("data-kt-indicator");
              submitButton.value?.removeAttribute("disabled");
            })
            .catch((response) => {
              if (!helpers) {
                return
              }
              helpers.handleResponse(response, t, router, store, {setErrors});
              //Deactivate indicator
              submitButton.value?.removeAttribute("data-kt-indicator");
              submitButton.value?.removeAttribute("disabled");
            });

      }, 100);
    };

    return {
      ...toRefs(state),
      onSubmitLogin,
      submitButton,
    };
  },
});
</script>

<style>
.form-check.form-check-solid .form-check-input:checked{
  background-color: #E50019!important;
}
</style>
